import * as React from 'react';

const CreditCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path d="M28 8.51v14.975c0 .512-.18.948-.539 1.307a1.78 1.78 0 0 1-1.307.539H5.846a1.78 1.78 0 0 1-1.307-.539A1.78 1.78 0 0 1 4 23.485V8.51c0-.512.18-.948.539-1.307a1.78 1.78 0 0 1 1.307-.539h20.308c.512 0 .948.18 1.307.539.36.359.539.795.539 1.307ZM5.026 11.887h21.948V8.51c0-.205-.085-.393-.256-.564-.171-.17-.359-.256-.564-.256H5.846c-.205 0-.393.085-.564.256-.17.171-.256.36-.256.564v3.377Zm0 2.685v8.913c0 .205.085.393.256.564.171.17.359.256.564.256h20.308c.205 0 .393-.085.564-.256.17-.171.256-.36.256-.564v-8.913H5.026Z" />
    </g>
  </svg>
);

export default CreditCardIcon;
